import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/content";
import { LogoMark } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-[#0F172A] text-slate-200" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10 py-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-2.5 mb-5">
            <LogoMark size={30} onDark />
            <span className="text-lg font-semibold tracking-tight text-white">{BRAND.name}</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
            A boutique advisory for industrial manufacturers. We treat cash velocity as the primary product of operations —
            and constraint theory as the operating system.
          </p>
        </div>

        <div className="lg:col-span-2">
          <div className="text-[11px] tracking-[0.22em] uppercase text-slate-500 mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-white text-slate-300">Services</Link></li>
            <li><Link to="/diagnostic" className="hover:text-white text-slate-300">Diagnostic</Link></li>
            <li><Link to="/dashboard" className="hover:text-white text-slate-300">Dashboard</Link></li>
            <li><Link to="/case-studies" className="hover:text-white text-slate-300">Case Studies</Link></li>
            <li><Link to="/insights" className="hover:text-white text-slate-300">Insights</Link></li>
            <li><Link to="/about" className="hover:text-white text-slate-300">About Founder</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-[11px] tracking-[0.22em] uppercase text-slate-500 mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-slate-500" /> {BRAND.city}</li>
            <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 text-slate-500" /> <a href={`mailto:${BRAND.email}`} className="hover:text-white break-all">{BRAND.email}</a></li>
            <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 text-slate-500" /> <a href={`mailto:${BRAND.serviceEmail}`} className="hover:text-white break-all">{BRAND.serviceEmail}</a></li>
            <li className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 text-slate-500" /> <a href={`tel:${BRAND.phone.replace(/\s+/g,'')}`} className="hover:text-white">{BRAND.phone}</a></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-[11px] tracking-[0.22em] uppercase text-slate-500 mb-4">Start</div>
          <p className="text-sm text-slate-300 mb-4 leading-relaxed">
            Two hours. One constraint. A quantified 30-90 day plan.
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="inline-flex items-center gap-1.5 rounded-full bg-white text-slate-900 text-[13px] font-semibold px-4 py-2 hover:bg-slate-100 transition-colors"
          >
            Book working session <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} {BRAND.name} Consulting. All rights reserved.</span>
          <span>Cash Flow Above All.</span>
        </div>
      </div>
    </footer>
  );
}
